import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {BehaviorSubject, distinctUntilChanged, filter} from "rxjs";
import {Analytics, logEvent} from "@angular/fire/analytics";
import {Router} from "@angular/router";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  currentLang$ = new BehaviorSubject(null);
  availableLangs = ['nl', 'en', 'de', 'fr'];

  constructor(
    private analytics: Analytics,
    private router: Router,
    // inject locale
    @Inject(LOCALE_ID) protected localeId: string
  ) {
    const lang = localStorage.getItem('lang');
    if (lang && this.availableLangs.includes(lang)) {
      this.currentLang$.next(lang);
    }

    this.currentLang$.pipe(
      distinctUntilChanged(),
      filter((lang: string) => lang !== null)
    ).subscribe((lang: string) => {
      localStorage.setItem('lang', lang);
      console.log('Language changed', lang);
      if(environment.production) {
        console.log('Locale ID', this.localeId);
        console.log('Current route', this.router.url, `/${lang}`);
        this.handleLanguageChange(lang);
        // window.location.href = `/${lang}`;
      }
      // window.location.href = `/${lang}`;
      logEvent(this.analytics, 'change_language', {"language": lang});
    });
  }

  private handleLanguageChange(lang: string) {
    const currentLang = this.getCurrentLanguageFromUrl();
    console.log('Current language', currentLang)
    if (currentLang && currentLang !== lang) {
      console.log('Changing language', currentLang, lang);
      window.location.href = window.location.href.replace(`/${currentLang}/`, `/${lang}/`);
    }
  }

  private getCurrentLanguageFromUrl(): string {
    // Assuming your URL structure is like '/en/some-path'
    const path = window.location.pathname.split('/');
    // The language code is expected to be the second segment in the URL
    return path[1];
  }
}
